import axios from "axios";
import { getCookie } from "../../App";
import { domain } from "../Links/Links";
export async function editProfileRequest(
  fullname,
  username,
  email,
  setRequestStatus,
  setCurrentUserFullname,
  setCurrentUserUsername,
  setCurrentUserEmail,
) {
  console.log(fullname);
  console.log(username);
  console.log(email);
  setRequestStatus(true);
  const data = {
    fullname: fullname,
    username: username,
    email: email,
  };
  const response = await axios.post(
    domain + "/edit_profile/",
    data,
    {
      withCredentials: true,
      headers: {
        "X-CSRFToken": getCookie("csrf_token"),
      },
    },
  );

  if (response.data) {
    setRequestStatus(false);

    setCurrentUserFullname(data.fullname)
    setCurrentUserUsername(data.username)
    if (data.email) {
        setCurrentUserEmail(data.email)
    }
  }

  
}
